import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type SugarEditExpenditureResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useUnlockExpenditure = () => {
  const queryClient = useQueryClient()
  const sugar = useSugarContext()

  return useMutation({
    mutationKey: ['unlockExpenditure'],
    mutationFn: async (expenditureId: string) => {
      const { data } = await apiClient.post<SugarEditExpenditureResponse>('/api/expenditures/unlock', {
        expenditureId
      })

      return data
    },
    onSuccess: async (data) => {
      const { schoolYearId, quarterId, providerId } = data.data

      queryClient.setQueryData(
        ['expenditure', sugar?.isProviderRequired ? [schoolYearId, quarterId, providerId] : [schoolYearId, quarterId]],
        data
      )

      await queryClient.invalidateQueries({
        queryKey: ['expenditures']
      })

      return data
    }
  })
}
